module.exports = __webpack_public_path__ + "static/media/S1-3-Katarb-cod3.a8f7438e.png";